import { render } from "./Page.vue?vue&type=template&id=dba1a16e"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=dba1a16e&lang=scss"
script.render = render

export default script